<template>
  <section class="wrap">
    <div class="container-wrap">
      <div class="left">
        <div class="title-sub">기업 고객이신가요?</div>
        <div class="title" style="margin-top: 20px">
          기업 고객을 위한<br />API주문 연동 서비스
        </div>
        <div class="button-wrap">
          <button @click="openApiDocument()" class="ghost outline">
            API 문서 바로가기
          </button>
        </div>
      </div>
      <div class="right">
        <img src="@/assets/img/home/api.png" />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    openApiDocument() {
      window.open(`https://dver-openapi.oopy.io/`);
    }
  }
};
</script>
<style src="../home.common.css" scoped />
<style scoped>
.container-wrap {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

img {
  width: 100%;
}
.button-wrap {
  margin-top: 20px;
}

@media (min-width: 1024px) {
  img {
    width: 490px;
    height: 490px;
  }

  .container-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .button-wrap {
    margin-top: 40px;
  }

  .left {
    width: 405px;
  }

  .right {
    transition: transform 0.3s ease;
  }
  .right:hover {
    transform: translateY(-20px);
  }
}
</style>
